import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useHistory, Link ,Redirect} from "react-router-dom";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Login.css";
// import {Link} from "react-router-dom";

const Login = () => {
  const { enqueueSnackbar } = useSnackbar();
  const url=config.endpoint+"/auth/login";
  const [loginDetails, setLoginDetails] = useState({
    loading: false,
    username: "",
    password: "",
    redirectToReferrer:false
  });
  const history=useHistory();
  // TODO: CRIO_TASK_MODULE_LOGIN - Fetch the API response
  /**
   * Perform the Login API call
   * @param {{ username: string, password: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/login"
   *
   * Example for successful response from backend:
   * HTTP 201
   * {
   *      "success": true,
   *      "token": "testtoken",
   *      "username": "criodo",
   *      "balance": 5000
   * }
   *
   * Example for failed response from backend:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Password is incorrect"
   * }
   *
   */
  const handleChange=name=>event=>{
    setLoginDetails({...loginDetails,[name]:event.target.value})
  }
  const {username,password,redirectToReferrer}=loginDetails;
  const login = async (formData) => {
    // setLoginDetails({...loginDetails,loading:true})
    let isValid=false;
    formData.preventDefault();
    console.log(loginDetails);
    isValid=validateInput({username,password});
    if(isValid)
    {
      setLoginDetails({...loginDetails,loading:true})
      await axios.post(config.endpoint+"/auth/login", JSON.stringify({
        username: loginDetails.username,
        password: loginDetails.password
      }), {
        headers: {
          'content-type': 'application/json'
        }
    })
    .then((res)=>{
      console.log("Logged in successfully");
      console.log(res.data);
      // setLoginDetails({...loginDetails,loading:false});
      enqueueSnackbar("Logged in successfully",
          {
            variant: 'success',
          });
          // redirectUser();
          persistLogin(res.data.token, res.data.username,res.data.balance)
          history.push("/", { from: "Login" })
      })
    .catch((err)=>{
      // console.log("err:status",err.response.status);
        if (err.response)
        {
          if(err.response.status===400)
          {
            console.log(err.response.data.message);
            setLoginDetails({...loginDetails,loading:false})
            enqueueSnackbar(err.response.data.message,
              {
                variant: "error"
              });
          }
          else
          {
            console.log("Something went wrong. Check that the backend is running, reachable and returns valid JSON.")
            setLoginDetails({...loginDetails,loading:false})
            enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and returns valid JSON.",
            {
              variant: "error"
            });
          }
        }
      })
      // setRegisterDetails({...registerDetails,loading:false})
      // setLoginDetails({...loginDetails,username: "",
      //   password: "",
      //   })
    }
    // setLoginDetails({...loginDetails,loading:false});
  };

  const redirectUser=()=>{
    if(redirectToReferrer){
      return <Redirect to="/" />
    }
}
  // TODO: CRIO_TASK_MODULE_LOGIN - Validate the input
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false and show warning message if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that password field is not an empty value - "Password is a required field"
   */
  const validateInput = ({username,password}) => {
    let flag=true;
    if(username==="")
    {
      console.log("Username is a required field")
            enqueueSnackbar("Username is a required field",
            {
              variant: "warning"
            });
      flag=false;
      return flag;
    }
    if(password==="")
    {
      console.log("Password is a required field")
            enqueueSnackbar("Password is a required field",
            {
              variant: "warning"
            });
      flag=false;
      return flag;
    }
    return flag;
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Persist user's login information
  /**
   * Store the login information so that it can be used to identify the user in subsequent API calls
   *
   * @param {string} token
   *    API token used for authentication of requests after logging in
   * @param {string} username
   *    Username of the logged in user
   * @param {string} balance
   *    Wallet balance amount of the logged in user
   *
   * Make use of localStorage: https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
   * -    `token` field in localStorage can be used to store the Oauth token
   * -    `username` field in localStorage can be used to store the username that the user is logged in as
   * -    `balance` field in localStorage can be used to store the balance amount in the user's wallet
   */
  const persistLogin = (token, username, balance) => {
    localStorage.setItem('token', token);
    localStorage.setItem('username', username);
    localStorage.setItem('balance', balance);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="55vh"
    >
      <Header hasHiddenAuthButtons />
      <Box className="content" style={{position: 'relative'}}>
        <Stack spacing={2} className="form">
          <h2 className="title">Login</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Username"
            fullWidth
            value={loginDetails.username}
            onChange={handleChange('username')}
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            // helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Password"
            value={loginDetails.password}
            onChange={handleChange('password')}
          />
          
          <Button className="button" variant="contained" 
          onClick={login}
          >
            LOGIN TO QKART
           </Button>
          <p className="secondary-action">
          Don’t have an account? {" "}
             {/* <a className="link" href="#">
             Register now
             </a> */}
             <Link to="/register">Register now</Link>
          </p>
          {/* {redirectUser()} */}
        </Stack>
      </Box>
      <Footer />
      {/* {redirectUser()} */}
    </Box>
  );
};

export default Login;
